<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!--  -->
              <h4>{{ locked ? 'Unlock' : 'Lock' }} User</h4>
              <p>
                UserName: <strong>{{ UserName }}</strong>
              </p>
              <p>
                Name: <strong>{{ Name }}</strong>
              </p>
              <p>Why is this user being {{ locked ? 'unlocked' : 'locked' }}?</p>

              <p>
                <textarea v-model="Comment" cols="60" rows="5" name="comments"></textarea>
              </p>

              <div>
                <button class="btn btn-primary mr-3" @click="updateLockStatus">{{ locked ? 'Unlock' : 'Lock' }} User</button>
              </div>
              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import DivvyAdminSidebar from '@/views/divvyadmin/divvyAdminSidebar.vue';

export default {
  name: 'UsersLockUserScreen',
  props: ['id'],
  data() {
    return {
      UserName: '',
      Name: '',
      locked: null,
      Comment: '',
    };
  },
  components: {
    DivvyAdminSidebar,
    Header,
    Footer,
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch('divvyAdminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'usersmodule',
        activeMenu: this.activeMenu ? this.activeMenu : 'clientusermanagement',
      });
    },
    updateLockStatus() {
      let payload = {
        userId: Number(this.id),
        isLocked: !this.locked,
        comment: this.Comment,
      };
      console.log(payload);

      this.$store
        .dispatch('manageUsers/setLockStatus', payload)
        .then(() => {
          this.$store.dispatch('manageUsers/fetchGetUsers');
        })
        .then(() =>
          this.$router.push({
            name: 'DivvyAdminUsersAddUpdScreen',
            params: {
              Name: this.Name,
              action: this.locked ? 'unlocked' : 'locked',
            },
          })
        );
    },
  },

  created() {
    this.setActiveMenuItem();
    this.$store
      .dispatch('manageUsers/fetchExistingDetails', {
        userId: this.id,
      })
      .then((data) => {
        this.UserName = data.username;
        this.Name = data.lastName + ',' + data.firstName;
        this.locked = data.locked;
      });
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
